import React from "react";
import { ThemeProvider as MuiThemeProvider } from "@material-ui/styles";
import theme from 'Theme'


function ThemeProvider({ children }) {
  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
}

export default ThemeProvider;



// WEBPACK FOOTER //
// ./src/components/AppContainer/App/ThemeProvider.js